import styled from 'styled-components'

const Color = ({ onChange, label }) => (
  <Label>
    <Text>{label}</Text>
    <input type="color" onChange={onChange} />
  </Label>
)

export default Color

const Label = styled.label({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  padding: '10px 0',
})

const Text = styled.span({
  paddingRight: 10,
  color: 'rgba(0, 0, 0, 0.54)',
  fontSize: 14,
})
